import { Title } from '../../components/Title/Title';
import { AppShell } from '../../components/AppShell/AppShell';
import { Accordion, AccordionContext, Alert, Button, Card, Container, Modal, ModalBody, useAccordionToggle, Tab, Tabs, Form } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import styles from './Shop.module.scss';
import { useContext, useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faCircleNotch, faCreditCard, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useStripe } from '@stripe/react-stripe-js';
import { useQuery } from '../../../hooks/useQuery';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { useTranslation } from 'react-i18next';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { CloudFunctions, formatSecondsTimestamp, isItalian, getFunctionsUrl, shouldCompleteFirstLogin } from '../../utils/utils';
import { LoginModal } from '../../components/LoginModal/LoginModal';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { Browser } from '@capacitor/browser';
import { If, Then } from 'react-if';
import { useGeolocation } from '../../../contexts/GeolocationContext';
import { ConfirmationModal } from '../../components/ConfirmationModal/ConfirmationModal';
import { HighlightedCard } from '../../components/HighlightedCard/HighlightedCard';

const nf = new Intl.NumberFormat(undefined, { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatDuration = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours} ore ${minutes} minuti`;
};

const ShopComponent = () => {
  const stripe = useStripe();
  const {
    buyShop,
    userDataFmt,
    getFadCourses,
    isLoggedIn,
    currentUser,
    subscription,
    getEcmPackages,
    addCheckoutSession,
    fadSubscribeToCourses,
    updateCustomerSubscription,
    updateUserData,
    getCustomerPortalUrl,
    staticData
  } = useFirebase();
  const { currentLanguage, currentLocale } = useCurrentLanguage();
  const { t } = useTranslation();
  const { comesFromPublicShop, selectedProductSlug, fs, selectedProductId, selectedProductPriceId } = useQuery();
  const history = useHistory();
  const { country_code } = useGeolocation();

  const { isNative } = useCapacitor();

  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fadProducts, setFadProducts] = useState<[]>(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productDetailModalOpen, setProductDetailModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isBuyLoading, setIsBuyLoading] = useState(false);
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [isRedirectModal, setIsRedirectModal] = useState(false);
  const [allreadyGoingToCheckout, setAllreadyGoingToCheckout] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('ecm-courses');
  const [ECMPackages, setECMPackages] = useState<[]>(null);
  const [selectCoursesView, setSelectCoursesView] = useState(false);
  const [selectedCourses, setSelectedCourses] = useState<any[]>([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentlyAvailableCredits, setCurrentlyAvailableCredits] = useState(0);
  const [tmpAvailableCredits, setTmpAvailableCredits] = useState(0);
  const [totalInitialCreditsAmount, setTotalInitialCreditsAmount] = useState(0);
  const [previousCreditBalance, setPreviousCreditBalance] = useState<number | null>(null);
  const [acceptConditions, setAcceptConditions] = useState<boolean>(false);
  const [blackFridayBanner, setBlackFridayBanner] = useState<string>(null);
  const [isConfirmInfoModalOpen, setIsConfirmInfoModalOpen] = useState(false);
  /** UPGRADE MODAL HOOKS */
  const [isPlanUpgradeModalOpen, setIsPlanUpgradeModalOpen] = useState(false);
  const [planUpgradeLoading, setPlanUpgradeLoading] = useState(false);
  const [planUpgradeData, setPlanUpgradeData] = useState<any>(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [errorCase, setErrorCase] = useState('');
  const [isErrorPaymentModalOpen, setIsErrorPaymentModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [successCourseModalOpen, setSuccessCourseModalOpen] = useState(false);
  const [portalUrlLoading, setPortalUrlLoading] = useState(false);

  const teacherDescriptions = {
    'ESTETICA': 'shop.ECMShopDocentiEstetica',
    'RESTAURI_POSTERIORI': 'shop.ECMShopDocentiRestauriPosteriori',
    'CHIRURGIA_AVANZATA': 'shop.ECMShopDocentiChirurgiaAvanzata',
    'CHIRURGIA_PARIO_START': 'shop.ECMShopDocentiChirurgiaPerioStart',
    'ENDODONZIA': 'shop.ECMShopDocentiEndodonzia',
    'DEAFULT': 'shop.ECMShopDocentiDefault',
  }

  useEffect(() => {
    if (!fs) return;
    setSuccessModalOpen(true);
  }, []);

  useEffect(() => {
    if (!staticData) return;
    try {
      const blackFridayBanner = staticData.BLACK_FRIDAY_BANNER;
      setBlackFridayBanner(blackFridayBanner);
    } catch (e) {
      console.error(e);
    }
  }, [staticData]);

  useEffect(() => {
    if (!userDataFmt) return;

    const allSavedCourses = userDataFmt.selectedCoursesFromPackages || [];

    // Get newly selected courses in UI that haven't been saved yet
    const newlySelectedCourses = selectedCourses.filter(
      (c) => !allSavedCourses.find((sc) => sc.id === c.id)
    );

    // Calculate credits: only count NEW selections (courses not yet saved)
    // Saved courses are already accounted for in packageECMCurrentCreditBalance
    const creditsFromNewSelections = newlySelectedCourses.reduce(
      (acc, course) => acc + parseInt(course.credits), 0
    );

    setTmpAvailableCredits(currentlyAvailableCredits - creditsFromNewSelections);
  }, [currentlyAvailableCredits, selectedCourses, userDataFmt]);

  useEffect(() => {
    if (ECMPackages != null) return;
    const fetchECMPackages = async () => {
      setDataLoading(true);
      const uid = !isLoggedIn ? null : userDataFmt ? userDataFmt.uid : currentUser ? currentUser.uid : null;
      const response = await getEcmPackages(uid);
      if (response.status !== 'ok') {
        throw new Error(`Error fetching ECM packages: ${response.statusText}`);
      }
      const data = response.data;
      return data;
    }
    fetchECMPackages()
      .then((data: any) => {
        setECMPackages(data);
      })
      .catch(console.error)
      .finally(() => setDataLoading(false));
  }, []);

  useEffect(() => {
    if (!userDataFmt) return;
    const hasMonthlySubscription = subscription && subscription.items[0].price.recurring.interval === 'month' ? true : false;
    const subscriptionMetadata = subscription && subscription.items[0].price.product.metadata ? subscription.items[0].price.product.metadata : null;
    const shouldUpgrading =
      subscription &&
        userDataFmt.activeSubscription &&
        !hasMonthlySubscription &&
        comesFromPublicShop &&
        (selectedProductSlug === 'undefined' || !selectedProductSlug) &&
        selectedProductId &&
        selectedProductId !== 'undefined' &&
        selectedProductPriceId !== 'undefined' ? true : false;
    const hasAlreadyAccessToCourse =
      subscription &&
        subscriptionMetadata.IS_ECM_PACKAGE === 'yes' &&
        ((selectedProductSlug && selectedProductSlug !== 'undefined') || (selectedProductId && selectedProductId !== 'undefined')) ? true : false;
    const shouldAlertModalBeShown = userDataFmt && userDataFmt.ecmShopData &&
      userDataFmt.ecmShopData.find((item: any) => {
        return item.slug === selectedProductSlug && item.status === 'complete';
      }) ? true : false;
    const shouldRedirect = subscription &&
      (subscriptionMetadata.ECM_INCLUDED == 'yes' ||
        // ha un abbonamento mensile ed ha selezionato un pacchetto
        (hasMonthlySubscription && selectedProductPriceId !== 'undefined' && selectedProductPriceId !== undefined) ||
        // ha un mensile e non ha selezionato un corso singolo
        (hasMonthlySubscription && (!selectedProductSlug || selectedProductSlug == 'undefined'))
      ) ? true : false;
    const isAso = userDataFmt && userDataFmt.profile && userDataFmt.profile.formData &&
      userDataFmt.profile.formData.categoriaProfessionale == 'aso' ? true : false;
    if (shouldAlertModalBeShown && !shouldRedirect) {
      setLoading(true);
      const fetchFadCourses = async () => {
        const uid = !isLoggedIn ? null : userDataFmt ? userDataFmt.uid : currentUser ? currentUser.uid : null;
        setLoading(true);
        const response = await getFadCourses(uid);
        if (response.error) {
          throw new Error(`Error fetching FAD courses: ${response.error}`);
        }
        const data = await response.data;
        return data;
      };
      fetchFadCourses()
        .then((data: any) => {
          setFadProducts(data);
        })
        .catch(console.error)
        .finally(() => {
          setProductDetailModalOpen(false);
          setLoading(false);
        });
      setAlertModalOpen(true);
      return;
    } else if (shouldRedirect) {
      if (hasMonthlySubscription) {
        setDataLoading(true);
        const fetchFadCourses = async () => {
          const uid = !isLoggedIn ? null : userDataFmt ? userDataFmt.uid : currentUser ? currentUser.uid : null;
          setDataLoading(true);
          const response = await getFadCourses(uid);
          if (response.error) {
            throw new Error(`Error fetching FAD courses: ${response.error}`);
          }
          const data = await response.data;
          return data;
        };
        fetchFadCourses()
          .then((data: any) => {
            setFadProducts(data);
          })
          .catch(console.error)
          .finally(() => {
            setActiveTab('ecm-courses');
            setDataLoading(false)
          });
        return;
      } else {
        setIsRedirectModal(true);
        setAlertModalOpen(true);
        window.location.href = '/browse';
        return;
      }
    } else if (isAso) {
      // The user should not be able to neither access the shop nor buy a single course
      history.replace('/browse');
      return;
    } else if (shouldUpgrading) {
      if (subscriptionMetadata?.IS_ECM_PACKAGE && subscriptionMetadata?.IS_ECM_PACKAGE === 'yes') {
        // Forcing reload of the shop page without the query params
        window.location.href = '/shop';
        return;
      } else {
        setLoading(true);
        (async () => {
          await updateCustomerSubscription(
            subscription?.product?.id,
            null,
            null,
            null,
            true,
            true,
            selectedProductId
          ).then((pendingResult) => {
            if (!pendingResult) {
              setLoading(false);
              return null;
            }

            if ((pendingResult as any).error) {
              console.error('Error in result:', pendingResult);
              setLoading(false);
              setErrorCase((pendingResult as any).case);
              setIsErrorPaymentModalOpen(true);
              return null;
            }

            setPlanUpgradeData(pendingResult);
            setLoading(false);
            setIsPlanUpgradeModalOpen(true);

            return pendingResult;
          }).catch((error) => {
            console.error('Promise rejected:', error);
            setLoading(false);
            throw error;
          })
        })();
        return;
      }
    } else if (hasAlreadyAccessToCourse) {
      // Forcing reload of the shop page without the query params
      window.location.href = '/shop';
      return;
    } else {
      (async () => {
        const shouldGoToCheckout: boolean =
          comesFromPublicShop &&
            (selectedProductSlug &&
              (selectedProductSlug !== 'undefined' ||
                (selectedProductPriceId &&
                  selectedProductPriceId !== 'undefined'))) &&
            !!currentUser &&
            !!userDataFmt &&
            (!userDataFmt.activeSubscription || !userDataFmt.activeSubscription == false) &&
            (!userDataFmt.activeSubscription || !userDataFmt.activeSubscription.length) &&
            !shouldCompleteFirstLogin(userDataFmt) ? true : false;
        if (shouldGoToCheckout) {
          if (allreadyGoingToCheckout || (userDataFmt?.activeSubscription && selectedProductPriceId && selectedProductPriceId !== 'undefined')) return;
          setAllreadyGoingToCheckout(true);
          setLoading(true);
          const productToBuy = selectedProductSlug && selectedProductSlug !== 'undefined' ? selectedProductSlug : selectedProductPriceId;
          if (selectedProductSlug === 'undefined') {
            await addCheckoutSession(productToBuy, null, false, true, true)
              .then(async ({ sessionId, url }) => {
                setECMPackages(null);
                if (isNative) {
                  await Browser.open({ url });
                } else {
                  stripe.redirectToCheckout({ sessionId });
                }
              })
              .catch((error) => {
                console.error(error);
              });
            return;
          } else {
            const { id, url } = await buyShop(selectedProductSlug);
            stripe.redirectToCheckout({ sessionId: id });
            return;
          }
        }
        return;
      })();
    }
  }, [userDataFmt, comesFromPublicShop, selectedProductSlug, selectedProductPriceId, subscription]);

  useEffect(() => {
    if (fadProducts != null) return;
    // Fetch FAD courses if needed
    const fetchFadCourses = async () => {
      const uid = !isLoggedIn ? null : userDataFmt ? userDataFmt.uid : currentUser ? currentUser.uid : null;
      setDataLoading(true);
      const response = await getFadCourses(uid);
      if (response.error) {
        throw new Error(`Error fetching FAD courses: ${response.error}`);
      }
      const data = await response.data;
      return data;
    };
    fetchFadCourses()
      .then((data: any) => {
        setFadProducts(data);
      })
      .catch(console.error)
      .finally(() => setDataLoading(false));
  }, [isLoggedIn]);

  useEffect(() => {
    if (!subscription) return;
    if (!userDataFmt) return;
    if (subscription.items[0]?.price?.product?.metadata?.AVAILABLE_CREDITS) {
      setSelectCoursesView(true);

      const baseCredits = parseInt(subscription.items[0].price.product.metadata.AVAILABLE_CREDITS);
      const currentBalance = userDataFmt.packageECMCurrentCreditBalance !== undefined && userDataFmt.packageECMCurrentCreditBalance !== null
        ? parseInt(userDataFmt.packageECMCurrentCreditBalance)
        : baseCredits;
      if (previousCreditBalance !== null && currentBalance > previousCreditBalance) {
        setSelectedCourses(userDataFmt?.selectedCoursesFromPackages || []);
      } else if (previousCreditBalance === null) {
        setSelectedCourses(userDataFmt?.selectedCoursesFromPackages || []);
      }

      setPreviousCreditBalance(currentBalance);
      setCurrentlyAvailableCredits(currentBalance);
      setTotalInitialCreditsAmount(baseCredits);
    }
  }, [subscription, userDataFmt]);

  const getLocalizedProperty = (item: any, prop: string) => {
    try {
      return item.metadata?.[`i18n.${prop}.${currentLanguage}`] || item[prop];
    } catch {
      return item[prop];
    }
  };

  if (userDataFmt && shouldCompleteFirstLogin(userDataFmt)) {
    return <Redirect to={`/first-login?comesFromPublicShop=${comesFromPublicShop}&selectedProductSlug=${(selectedProduct as any).slug}&selectedProductId=${(selectedProduct as any).id}`} />;
  }

  const shouldRedirectToBrowse =
    currentLanguage !== 'it' ||
    (userDataFmt && userDataFmt?.profile?.formData?.categoriaProfessionale !== 'odontoiatra');

  if (shouldRedirectToBrowse) {
    return <Redirect to={'/browse'} />;
  }

  if (!fadProducts || dataLoading || loading) return <FullscreenLoader />;

  const ContextAwareToggle = ({ children, eventKey, callback = null }) => {
    const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));

    return (
      <div onClick={decoratedOnClick} className={styles.accordionToggle}>
        {children}
      </div>
    );
  };

  const ContextAwareChevron = ({ eventKey }) => {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
      <FontAwesomeIcon icon={isCurrentEventKey ? faChevronUp : faChevronDown} />
    );
  };

  const handleCourseSelection = async () => {
    setLoading(true);
    // Call the function to subscribe to the selected courses
    const currentlySelectedCourses = selectedCourses.filter((c) => !userDataFmt.selectedCoursesFromPackages?.find((sc) => sc.id === c.id));
    const signUpResponse = await fadSubscribeToCourses(currentlySelectedCourses.map((course: any) => ({
      id: course.id,
      name: course.name,
      bullet_points: course.bullet_points,
      slug: course.slug,
      price: course.price,
      credits: course.credits,
      unique_code: course.unique_code
    })), userDataFmt.id, userDataFmt.fad_id, userDataFmt.packageECMCurrentCreditBalance);
    if (!signUpResponse.success) {
      console.error('Error subscribing to courses:', signUpResponse.message);
      setLoading(false);
      setIsConfirmModalOpen(false);
      setIsErrorModalOpen(true);
      return;
    } else {
      const newlyFetchedCourses = await getFadCourses(userDataFmt.uid);
      setFadProducts(newlyFetchedCourses.data);
      setIsConfirmModalOpen(false);
      setLoading(false);
      setSuccessCourseModalOpen(true);
      await updateUserData();
    }
  };

  const handleModal = () => {
    setIsConfirmModalOpen(!isConfirmModalOpen);
    setIsBuyLoading(false);
    setAcceptConditions(false);
  };

  const handleDisabledCheckbox = (product) => {
    const currentlySelectedCourses = selectedCourses.filter((c) => !userDataFmt.selectedCoursesFromPackages?.find((sc) => sc.id === c.id));
    const previouslyBoughtCourses = userDataFmt.ecmShopData || [];
    const sirioCourses = userDataFmt.fadCourses || [];
    const totalAmountSelectedCourses = currentlySelectedCourses.reduce((acc, course) => acc + parseInt(course.credits), 0);
    const allowedOffset = subscription.items[0]?.price?.product?.metadata?.OFF_MARGIN || 0;
    const prevSelectedCourses = userDataFmt.selectedCoursesFromPackages || [];
    return (
      (parseInt(product.credits) + totalAmountSelectedCourses > currentlyAvailableCredits + parseInt(allowedOffset) && !selectedCourses.find((c) => c.id === product.id)) ||
      (!!selectedCourses.find((c) => c.id === product.id) && prevSelectedCourses.find((c) => c.id === product.id))
      || previouslyBoughtCourses.find((c) => c.fad_course_id === product.id)
      || sirioCourses.find((c) => c.id === product.id)
    );
  };

  const handleCloseModal = () => {
    setIsPlanUpgradeModalOpen(false);
    setIsBuyLoading(false);
  };

  const handleCloseErrorPaymentModal = () => {
    setIsErrorPaymentModalOpen(false);
    setIsBuyLoading(false);
  };

  const handleTabDisable = () => {
    if (!subscription) return false;
    const subscriptionRenewalCycle = subscription?.items[0]?.price?.recurring?.interval;
    return ECMPackages === null || !ECMPackages.length || subscriptionRenewalCycle === 'month';
  }

  const resumeCheckout = async () => {
    if (!isLoggedIn) {
      setIsConfirmInfoModalOpen(false);
      setIsLoginModalOpen(true);
      setIsBuyLoading(false);
      return;
    }
    setIsBuyLoading(true);
    if (!selectedProduct.isPackage) {
      buyShop(selectedProduct.slug ? selectedProduct.slug : (selectedCourses as any).id)
        .then(({ id }) => {
          setFadProducts(null);
          stripe.redirectToCheckout({ sessionId: id });
        })
        .catch(console.error)
        .finally(() => {
          setSelectedProduct(null);
          setIsBuyLoading(false);
        });
    } else {
      addCheckoutSession(selectedProduct.default_price.id, null, false, true, true)
        .then(async ({ sessionId, url }) => {
          if (isNative) {
            await Browser.open({ url });
          } else {
            stripe.redirectToCheckout({ sessionId });
          }
        })
        .catch(console.error)
        .finally(() => setIsBuyLoading(false));
    }
  };

  return (
    <AppShell contentClassName={styles.fullBleedContent}>
      <Title>{selectCoursesView ? t('shop.selezionaCorsi') : t('plans.labels.acquistaECM')}</Title>

      <div className={styles.shopPage}>
        {' '}
        {/*#region background  */}
        <div className={`text-center step-height ${styles.backgroundTopLayer}`}>
          <div className={styles.backgroundTopSide} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}copertina-shop.png)` }}></div>
        </div>

      <Container className={'my-5'}>
        {blackFridayBanner && isItalian(country_code) && !selectCoursesView ? (
          <div
            className={styles.headerContent}
            style={{ transform: blackFridayBanner && isItalian(country_code) && !selectCoursesView ? 'translateY(0vmin)' : 'translateY(20vmin)' }}
          >
            <div className={styles.shopStep}>
              <div className={`mb-3 ${styles.bannerHolder}`}>
                <img className={'w-100'} src={staticData.BLACK_FRIDAY_BANNER} alt="black friday promo" />
              </div>
            </div>
            {selectCoursesView ? (
               <div className={'display-4 text-center'}>{t('shop.selezionaCorsi')}</div>
            ) : (
              <>
                 <div className={'display-4 text-center'}>{t('shop.benvenutoNel')}</div>
                 <div className={'display-3 font-weight-bold mb-5 text-center'}>{t('shop.catalogoEcm')}</div>
              </>
            )}
          </div>
        ) : selectCoursesView ? (
           <div className={'display-4 text-center'}>{t('shop.selezionaCorsi')}</div>
        ) : (
          <>
             <div className={'display-4 text-center'}>{t('shop.benvenutoNel')}</div>
             <div className={'display-3 font-weight-bold mb-5 text-center'}>{t('shop.catalogoEcm')}</div>
          </>
        )}



        {!selectCoursesView ?
          <div className="tabbed-workspace">
          <Tabs activeKey={activeTab} onSelect={(target) => {
            if (target === "ecm-plans") setIsConfirmModalOpen(true);
            else setAcceptConditions(false);
            setActiveTab(target)
          }} className="tabbed-workspace-tabs" mountOnEnter={true} unmountOnExit={true}>
             <Tab eventKey="ecm-courses" title={t('shop.corsiEcm')}>
              <div className={styles.shopGrid}>
                {fadProducts.map((product: any) => (
                  <Card
                    className={`d-flex flex-row gradient-border`}
                    bg={'dark'}
                    key={product.id}
                    onClick={() => {
                      setSelectedProduct(product);
                      setProductDetailModalOpen(true);
                    }}
                  >
                    <div className={`${styles.paddingIgnorer} ${styles.smallContainer}`}>
                      <div
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}ecm/logo_tootor_stroke.png)` }}
                        className={`${styles.logoTootorDecoration} ${styles.smallLogo}`}
                      ></div>
                    </div>
                     <Card.Body className={styles.cardBody}>
                      <Card.Title className={styles.lineClampTitle}>{getLocalizedProperty(product, 'name')}</Card.Title>
                      <Card.Text className={styles.lineClampDescription}>
                        <span className={'font-weight-bold'}><b>{t('shop.ECMShopFooterCreditiStimati')}</b></span> <span>{product.credits}</span>
                        <br />
                        <span className={'font-weight-bold'}><b>{t('shop.ECMShopFooterDurataTotale')}</b></span> <span>{formatDuration(product.duration)}</span>
                        <br />
                      </Card.Text>
                    </Card.Body>
                     <div className={`${styles.cardBackgroundImage} ${styles.clickableCardImage} ml-auto`} style={{ backgroundImage: `url(${product.preview_img.full_path})` }} />
                     <div className={`d-flex flex-column justify-content-end pb-3 pr-3 ${styles.cardPriceActions}`}>
                      <h3>
                        <span className={'font-weight-bold'}>{nf.format(product?.bullets?.PRICE_ECM_SHOP / 100)}€</span> + IVA
                      </h3>
                      <Button
                        variant={product.is_buyable ? 'primary' : 'secondary'}
                        className="tootor-button tootor-button--secondary"
                        disabled={
                          !product.is_buyable ||
                          userDataFmt?.selectedCoursesFromPackages?.find((sc) => sc.id === product.id) ||
                          userDataFmt?.fadCourses?.find((c) => c.id === product.id) ||
                          isBuyLoading
                        }
                        onClick={(event) => {
                          event.stopPropagation();
                          if (!product.is_buyable) return;
                          setSelectedProduct(product);
                          setIsConfirmInfoModalOpen(true);
                        }}
                      >
                         {isBuyLoading && selectedProduct?.id == product.id ? <span>{t('labels.attendi')}&hellip;</span>
                           : <span>{t(product.is_buyable &&
                             !userDataFmt?.selectedCoursesFromPackages?.find((sc) => sc.id === product.id) &&
                             !userDataFmt?.fadCourses?.find((c) => c.id === product.id)
                             ? 'shop.acquista' : 'shop.giaAcquistato')}</span>
                         }
                      </Button>
                    </div>
                  </Card>
                ))}
              </div>
            </Tab>
             <Tab eventKey="ecm-plans" title={t('shop.pacchettiEcm')} disabled={handleTabDisable()}>
              <div className={styles.shopGrid}>
                {ECMPackages && ECMPackages.map((ecmPackage: any) => (
                  <Card
                    className={'d-flex flex-row gradient-border'}
                    bg={'dark'}
                    key={ecmPackage.id}
                    onClick={() => {
                      setSelectedProduct({ ...ecmPackage, isPackage: true });
                      setProductDetailModalOpen(true);
                    }}
                  >
                    <div className={`${styles.paddingIgnorer} ${styles.smallContainer}`}>
                      <div
                        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}ecm/logo_tootor_stroke.png)` }}
                        className={`${styles.logoTootorDecoration} ${styles.smallLogo}`}
                      ></div>
                    </div>
                     <Card.Body className={styles.cardBody}>
                      <Card.Title className={styles.lineClampTitle}>{getLocalizedProperty(ecmPackage, 'name')}</Card.Title>
                      <Card.Text className={styles.lineClampDescription}>
                        <span className={'font-weight-bold'}><b>{t('shop.ECMShopFooterCreditiStimati')}</b></span> <span>{ecmPackage.metadata.AVAILABLE_CREDITS}</span>
                      </Card.Text>
                    </Card.Body>
                     <div className={`${styles.cardBackgroundImageTop} ${styles.clickableCardImage} ml-auto`} style={{ backgroundImage: `url(${ecmPackage.images[0]})` }} />
                     <div className={`d-flex flex-column justify-content-end pb-3 pr-3 ${styles.cardPriceActions}`}>
                      <h3>
                        <span className={'font-weight-bold'}>{nf.format(ecmPackage.default_price.unit_amount / 100 / 1.22)}€</span> + IVA
                      </h3>
                      <Button
                        variant={'primary'}
                        className="tootor-button tootor-button--secondary"
                        disabled={isBuyLoading}
                        onClick={(event) => {
                          event.stopPropagation();
                          setSelectedProduct({ ...ecmPackage, isPackage: true });
                          setIsBuyLoading(true);
                          if (!subscription) {
                            setIsConfirmInfoModalOpen(true);
                          } else {
                            // User has a subscription, so he can only upgrade
                            updateCustomerSubscription(subscription.product.id, null, null, null, true, true, ecmPackage.id)
                              .then((pendingResult) => {
                                if (!pendingResult) return;
                                if ((pendingResult as any).error) {
                                  setErrorCase((pendingResult as any).case);
                                  setIsErrorPaymentModalOpen(true);
                                  return;
                                }
                                setPlanUpgradeData(pendingResult);
                                setIsPlanUpgradeModalOpen(true);
                              })
                              .catch(console.error)
                              .finally(() => {
                                setPlanUpgradeLoading(false);
                              });
                          }
                        }}
                      >
                        {isBuyLoading && selectedProduct?.id == ecmPackage.id ? <span>{t('labels.attendi')}&hellip;</span>
                          : <span>{t('shop.acquistaPacchetto')}</span>
                        }
                      </Button>
                    </div>
                  </Card>
                ))}
              </div>
            </Tab>
          </Tabs>
          </div> :
          <>
            <Form>
              <Form.Group controlId="selectCourses">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Form.Label className="mb-0">
                    Seleziona i corsi che vuoi integrare nel tuo piano in abbonamento, hai ancora
                    <span className={
                      tmpAvailableCredits > (totalInitialCreditsAmount / 1.5) ?
                        'text-success' :
                        tmpAvailableCredits > (totalInitialCreditsAmount / 4) ?
                          'text-warning' :
                          'text-danger'
                    }> {tmpAvailableCredits}</span> crediti da utilizzare
                  </Form.Label>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleModal()}
                    disabled={!selectedCourses.length || !selectedCourses.filter((c) => !userDataFmt.selectedCoursesFromPackages?.find((sc) => sc.id === c.id)).length}
                  >
                    Salva
                  </Button>
                </div>
                {fadProducts && fadProducts.length > 0 ? (
                  <Accordion>
                    {fadProducts.map((product: any) => (
                      <Card key={product.id} className={`${styles.ecmShopCard} mb-3`}>
                        <Card.Header className={styles.ecmShopHeader}>
                          <div className="d-flex align-items-center w-100">
                             <div onClick={(e) => e.stopPropagation()} className={`checkbox-container me-4 ${styles.checkboxPadding}`}>
                              <Form.Check
                                type="checkbox"
                                checked={
                                  selectedCourses.find((c) => c.id === product.id) ||
                                  userDataFmt.ecmShopData?.find((c) => c.fad_course_id === product.id) ||
                                  userDataFmt.fadCourses?.find((c) => c.id === product.id) ?
                                  true : false
                                }
                                disabled={handleDisabledCheckbox(product)}
                                onChange={(e) => {
                                  const { checked } = e.target;
                                  setSelectedCourses((prev) => {
                                    if (checked) {
                                      return [...prev, product];
                                    } else {
                                      return prev.filter((prod) => {
                                        return prod.id !== product.id
                                      });
                                    }
                                  });
                                }}
                                 className={styles.customCheckbox}
                              />
                            </div>

                            <ContextAwareToggle eventKey={product.id}>
                              <div className="flex-grow-1 d-flex justify-content-between align-items-center w-100">
                                <div className="flex-grow-1">
                                  <div className="fw-bold">{getLocalizedProperty(product, 'name')}</div>
                                  <div className="text-muted small">
                                    {product.credits} crediti
                                  </div>
                                </div>
                                <div className="ms-3 flex-shrink-0">
                                  <ContextAwareChevron eventKey={product.id} />
                                </div>
                              </div>
                            </ContextAwareToggle>
                          </div>
                        </Card.Header>
                        <Accordion.Collapse eventKey={product.id}>
                           <Card.Body className={styles.ecmShopBody}>
                            <div className="row">
                              <div className="col-md-8">
                                <div className="d-flex flex-column gap-3">
                                  <div>
                                     <span className={`font-weight-bold ${styles.anchorText}`}>{t('shop.ECMShopFooterCreditiStimati')}</span>
                                     <span className={`${styles.anchorValue} ml-2`}>{product.credits}</span>
                                  </div>
                                  <div>
                                     <span className={`font-weight-bold ${styles.anchorText}`}>{t('shop.ECMShopFooterDurataTotale')}</span>
                                     <span className={`${styles.anchorValue} ml-2`}>{formatDuration(product.duration)}</span>
                                  </div>
                                  <div>
                                     <span className={`font-weight-bold ${styles.anchorText}`}>{t('shop.ECMShopFooterDataScadenza')}</span>
                                      <span className={`${styles.anchorValue} ${styles.deadlineValue} ml-2`}>
                                      {product.end_date ? new Date(product.end_date).toLocaleDateString() : 'N/A'}
                                    </span>
                                  </div>
                                  <div>
                                     <span className={'font-weight-bold d-block mb-2'}>{t('labels.descrizione')}</span>
                                     <div className={styles.descriptionContent}
                                      dangerouslySetInnerHTML={{
                                        __html: (getLocalizedProperty(product, 'description') || '')
                                          .replace(/<ul>/g, '<ul class="list-unstyled">')
                                          .replace(/<li>/g, '<li class="mb-2">')
                                      }}
                                    />
                                  </div>
                                  {product.teachers && product.teachers.length > 0 && (
                                    <div>
                                      <span className={'font-weight-bold d-block mb-2'}>{t('shop.ECMShopDocenti')}</span>
                                      <div className={'row'}>
                                        {product.teachers.map((teacher: any) => (
                                          <div className={'col-6 mb-2'} key={teacher.id}>
                                            <span>{teacher.full_name}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                {product.preview_img && (
                                  <div
                                     className={`w-100 rounded ${styles.coursePreviewImage}`}
                                     style={{
                                       backgroundImage: `url(${product.preview_img.full_path})`,
                                     }}
                                  />
                                )}
                              </div>
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    ))}
                  </Accordion>
                ) : (
                  <Form.Text className="text-muted">Nessun corso disponibile</Form.Text>
                )}
              </Form.Group>
            </Form>
          </>
        }
      </Container>

      <div className={styles.backgroundBottomLayer}>
        <div className={styles.backgroundBottomSide} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}copertina-shop.png)` }}></div>
      </div>
      <Footer />
      </div>

      {/* Confirm modal before buy */}
      <ConfirmationModal
        show={isConfirmInfoModalOpen}
        onHide={() => {
          setIsConfirmInfoModalOpen(false);
          setSelectedProduct(null);
          setIsBuyLoading(false);
        }}
        title={t('labels.confirmInfoModalTitle')}
        onConfirm={resumeCheckout}
      >
        <h2>{t('labels.confirmInfoModalSubtitle')}</h2>
        <div>
          {t('labels.confirmInfoModalDescription1')}
          <br />
          {t('labels.confirmInfoModalDescription2')}
        </div>
      </ConfirmationModal>

      {/* Error Payment modal */}
        <Modal className="tootor-modal" centered={isNative} show={isErrorPaymentModalOpen} backdrop={'static'} onHide={handleCloseErrorPaymentModal}>
        <Modal.Header>
          <Modal.Title>{t(errorCase === 'missing_card' ? 'buyEcm.labels.planUpdateErrorPaymentTitle' : 'buyEcm.labels.planUpdateErrorPaymentTitle2')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('buyEcm.labels.planUpdateErrorPayment')}</p>
          <p>{t('buyEcm.labels.planUpdateErrorPayment2')}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
             className="tootor-button tootor-button--secondary"
            disabled={portalUrlLoading}
            onClick={() => {
              setPortalUrlLoading(true);
              getCustomerPortalUrl(true)
                .then(async (res) => {
                  if (isNative) {
                    await Browser.open({ url: res.url });
                  } else window.location.href = res.url;
                })
                .finally(() => setPortalUrlLoading(false));
            }}>
            {portalUrlLoading && <FontAwesomeIcon className={'mr-2'} icon={faCircleNotch} spin />}
            {portalUrlLoading ? <span>{t('labels.attendi')} &hellip;</span> : <span>{t('profile.labels.gestisciPiano')}</span>}
          </Button>
           <Button className="tootor-button tootor-button--basic" onClick={handleCloseErrorPaymentModal}>
            {t('labels.chiudi')}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Error course selection */}
      <Modal className="tootor-modal" centered show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)} backdrop={'static'} keyboard={false}>
        <Modal.Body>
          <Modal.Title className={'mb-2'}>Qualcosa sembra essere andato storto!</Modal.Title>
          <div className={'d-flex justify-content-start mt-3'}>
            <p>
              <span>Si è presentato un errore durante la selezione dei corsi.</span><br />
              <span>Ricarica la pagina per poter riprendere la navigazione.</span>
            </p>
          </div>
          <div className={'d-flex justify-content-start mt-3'}>
            <Button className="tootor-button tootor-button--basic" onClick={() => {
              setIsErrorModalOpen(false);
              window.location.reload();
            }}>
              Ricarica la pagina
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Success modal */}
      <Modal className="tootor-modal" centered show={successModalOpen} onHide={() => setSuccessModalOpen(false)} backdrop={'static'} keyboard={false}>
        <Modal.Body>
           <Modal.Title className={'mb-2'}>{t('shop.acquistoSuccesso')}</Modal.Title>
          <div className={'d-flex justify-content-start mt-3'}>
            <p>
              <span>{t('shop.acquistoSuccessoDescrizione1')}</span><br />
              <span>{t('shop.acquistoSuccessoDescrizione2')}</span><br />
              <span>{t('shop.acquistoSuccessoDescrizione3')}</span>
            </p>
          </div>
          <div className={'d-flex justify-content-start mt-3'}>
            <Button className="tootor-button tootor-button--basic" onClick={() => setSuccessModalOpen(false)}>
              {t('labels.chiudi')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Success course selection modal */}
      {/* TO DO - inserire traduzioni */}
      <Modal centered show={successCourseModalOpen} onHide={() => setSuccessCourseModalOpen(false)} backdrop={'static'} keyboard={false}>
        <Modal.Body>
          <Modal.Title className={'text-success mb-2'}>Operazione effettuata con successo</Modal.Title>
          <div className={'d-flex justify-content-start mt-3'}>
            <p>
              <span>Puoi già accedere al tuo corso o continuare a selezionare altri corsi da aggiungere al tuo pacchetto!</span>
            </p>
          </div>
          <div className={'d-flex justify-content-start mt-3'}>
            <Button variant={'outline-dark'} onClick={() => setSuccessCourseModalOpen(false)}>
              {t('labels.chiudi')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Error modal */}
      <Modal centered show={alertModalOpen} onHide={() => setAlertModalOpen(false)} backdrop={'static'} keyboard={false}>
        <Modal.Body>
          <div className={'d-flex justify-content-start mt-3'}>
            <p>
              <span><b>{!!isRedirectModal ? t('shop.ECMShopWarningSubscriberECMTitle') : t('shop.ECMShopWarningDoppioAcquistoTitle')}</b></span>
              <br />
              <br />
              {!!isRedirectModal ? t('shop.ECMShopWarningSubscriberECMDescription') : t('shop.ECMShopWarningDoppioAcquistoDescription')}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!!isRedirectModal ? (
            <>
              <Button variant={'warning'} onClick={async () => {
                setAlertModalOpen(false);
                setIsRedirectModal(false);
                const url = new URL(getFunctionsUrl(CloudFunctions.GetFadAuthenticatedUrl));
                url.searchParams.append('uid', currentUser.uid);
                url.searchParams.append('token', await currentUser.getIdToken(true));
                url.searchParams.append('email', currentUser.email);
                window.location.href = url.toString();
                setLoading(true);
              }}>
                {t('shop.ECMShopWarningGoECM')}
              </Button>
              <Button variant={'primary'} onClick={() => {
                setAlertModalOpen(false);
                setIsRedirectModal(false);
                history.replace('/browse');
              }}>
                {t('shop.ECMShopWarningKeepBrowse')}
              </Button>
            </>
          ) : (
            <Button variant={'primary'} onClick={() => {
              setAlertModalOpen(false);
              setIsRedirectModal(false);
            }}>
              {t('labels.chiudi')}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Login modal */}
      <LoginModal
        isModalOpen={isLoginModalOpen}
        setIsModalOpen={setIsLoginModalOpen}
        redirectTo={''}
        comesFromPublicShop={true}
        selectedProduct={selectedProduct}
        onAuth={null}
      />

      {/* Product detail modal */}
      {productDetailModalOpen && selectedProduct && (
        <Modal
          className={`${styles.productDetailModal} dark-modal ${styles.specialModal}`}
          centered
          show={productDetailModalOpen && selectedProduct}
          onHide={() => {
            setProductDetailModalOpen(false);
            setSelectedProduct(null);
          }}
        >
          <ModalBody className={'gradient-border'}>
            <button
              className={styles.modalCloseMobile}
              onClick={() => {
                setProductDetailModalOpen(false);
                setSelectedProduct(null);
              }}
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className={styles.paddingIgnorer}>
              <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}ecm/logo_tootor_stroke.png)` }} className={styles.logoTootorDecoration}></div>
            </div>
             <div className={`d-flex ${styles.detailScroll}`}>
              <div className={'d-flex flex-column flex-grow-1'}>
                <div className="d-flex align-items-center">
                  {<Modal.Title className={`flex-grow-1 ${styles.detailClampTitle}`}>{
                    !selectedProduct.isPackage ?
                      selectedProduct.categories.map((cat: any) => cat.name).join(', ') :
                      selectedProduct.name
                  }</Modal.Title>}
                </div>
                <div className={'d-flex flex-column mt-3'}>
                  <p className={'m-0'}>
                     {!selectedProduct.isPackage ? <span className={`font-weight-bold ${styles.anchorText} ${styles.detailProductName}`}>{getLocalizedProperty(selectedProduct, 'name')}</span> : null}
                  </p>
                  <p className={'m-0'}>
                    <span className={`font-weight-bold ${styles.anchorText}`}>{t('shop.ECMShopFooterCreditiStimati')}</span> <span className={styles.anchorValue}>{!selectedProduct.isPackage ? selectedProduct.credits : selectedProduct.metadata.AVAILABLE_CREDITS}</span>
                  </p>
                  {!selectedProduct.isPackage ?
                    <p className={'m-0'}>
                      <span className={`font-weight-bold ${styles.anchorText}`}><b>{t('shop.ECMShopFooterDurataTotale')}</b></span> <span className={styles.anchorValue}>{formatDuration(selectedProduct.duration)}</span>
                    </p> :
                    null}
                </div>
                <div className={'d-flex flex-column mt-3 gap-2'}>
                  <span className={'font-weight-bold'}>{t('labels.descrizione')}</span>
                  {!selectedProduct.isPackage ?
                     <div className={styles.descriptionContent} dangerouslySetInnerHTML={{ __html: getLocalizedProperty(selectedProduct, 'description').replace(/<ul>/g, '<ul class="list-unstyled">').replace(/<li>/g, '<li class="mb-2">') }} /> :
                    selectedProduct.metadata.PRODUCT_EXTENDED_DESCRIPTION ?
                       <div className={styles.descriptionContent}>
                        {t(`shop.${selectedProduct.metadata.PRODUCT_EXTENDED_DESCRIPTION}Block1`, { credits: selectedProduct.metadata.AVAILABLE_CREDITS })}<br />
                        {t(`shop.${selectedProduct.metadata.PRODUCT_EXTENDED_DESCRIPTION}Block2`)}<br /><br />
                         <span className={styles.descriptionEmphasis}>{t(`shop.${selectedProduct.metadata.PRODUCT_EXTENDED_DESCRIPTION}Block3`)}</span><br />
                        {fadProducts && fadProducts.length > 0 ?
                          <>
                            <ul className={'list-unstyled'}>
                              {fadProducts.map((course: any) => (
                                <li key={course.id}> {course.name} ({course.credits} {t('shop.ECMShopFooterCreditiStimati').replace(':', '')})</li>
                              ))}
                            </ul>
                          </> :
                          null
                        }
                      </div> :
                      <span>N/A</span>
                  }
                </div>
                {!selectedProduct.isPackage ?
                  <div className={'d-flex flex-column mt-3 gap-2'}>
                    <Accordion>
                      <Card key={'docenti'} className={styles.ecmShopCard}>
                        <ContextAwareToggle eventKey={'docenti'}><span className={'font-weight-bold'}>{t('shop.ECMShopDocenti')}</span></ContextAwareToggle>
                        <Accordion.Collapse eventKey={'docenti'}>
                          <Card.Body className={`${styles.ecmShopBody} pb-1 pt-1`}>
                            <div className={'d-flex flex-column mt-0'}>
                              <p>{t(teacherDescriptions[!!selectedProduct.category ? selectedProduct.category : 'DEFAULT'])}</p>
                            </div>
                            <div className={'row mb-4'}>
                              {selectedProduct.teachers && selectedProduct.teachers.length && selectedProduct.teachers.map((teacher: any) => (
                                <div className={'col-4 mb-2'} key={teacher.id}>
                                  <span>{teacher.full_name}</span>
                                </div>
                              ))}
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card key={'scheda_tecnica'} className={styles.ecmShopCard}>
                        <ContextAwareToggle eventKey={'scheda_tecnica'}><span className={'font-weight-bold'}>{t('shop.ECMShopSchedaTecnica')}</span></ContextAwareToggle>
                        <Accordion.Collapse eventKey={'scheda_tecnica'}>
                          <Card.Body className={`${styles.ecmShopBody} pb-1 pt-1`}>
                            <div className={`row mb-4 ${styles.descriptionContent}`}>
                              <ul className={'list-unstyled'}>
                                <li className={'mb-2'}>
                                  <span className={'font-weight-bold'}>{t('shop.ECMShopSchedaTecnicaProfessioniTarget')}:</span>
                                  <span className={'ml-2'}>{t('shop.ECMShopSchedaTecnicaProfessioniTargetValue')}</span>
                                </li>
                                <li className={'mb-2'}>
                                  <span className={'font-weight-bold'}>{t('shop.ECMShopSchedaTecnicaCodiceEvento')}:</span>
                                  <span className={'ml-2'}>{selectedProduct.unique_code || 'N/A'}</span>
                                </li>
                                <li className={'mb-2'}>
                                  <span className={'font-weight-bold'}>{t('shop.ECMShopSchedaTecnicaProviderECM')}:</span>
                                  <span className={'ml-2'}>288</span>
                                </li>
                                <li className={'mb-2'}>
                                  <span className={'font-weight-bold'}>{t('shop.ECMShopSchedaTecnicaEdizione')}:</span>
                                  <span className={'ml-2'}>{selectedProduct.ecm_edition_code || 'N/A'}</span>
                                </li>
                              </ul>
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div> :
                  <></>
                }
              </div>
            </div>
            <div className={`d-flex mt-1 align-items-center ${styles.modalFooterRow}`}>
              {!selectedProduct.isPackage ?
                  <div className={`d-flex flex-column ${styles.expiryMeta}`}>
                  <p className={'m-0'}>
                   <span className={`font-weight-bold ${styles.deadlineValue}`}>{t('shop.ECMShopFooterDataScadenza')} {selectedProduct.end_date ? new Date(selectedProduct.end_date).toLocaleDateString() : 'N/A'}</span>
                  </p>

                </div> :
                <></>
              }
               <div className={'d-flex flex-column justify-content-center my-0 mr-3 ml-auto'}>
                 <h3 className="mb-0">
                  <span className={'font-weight-bold'}>{
                    !selectedProduct.isPackage ?
                      nf.format(selectedProduct?.bullets?.PRICE_ECM_SHOP / 100) :
                      nf.format(selectedProduct?.default_price?.unit_amount / 100 / 1.22)
                  }€</span>  + IVA
                </h3>
              </div>
              <Button
                 className={`${styles.modalActionBtn} tootor-button tootor-button--primary`}
                 variant={selectedProduct.is_buyable || selectedProduct.isPackage ? 'primary' : 'secondary'}
                disabled={!selectedProduct.is_buyable && !selectedProduct.isPackage}
                onClick={() => {
                  if (!selectedProduct.is_buyable && !selectedProduct.isPackage) return;
                  setIsBuyLoading(true);
                  // TO DO - spostare la logica di acquisto effettivo dei prodotti dentro alla function resumeCheckout
                  if (!selectedProduct.isPackage || !subscription) {
                    // if (!selectedProduct.isPackage) {
                    //   buyShop(selectedProduct.slug ? selectedProduct.slug : (selectedCourses as any).id)
                    //     .then(({ id }) => {
                    //       stripe.redirectToCheckout({ sessionId: id });
                    //     })
                    //     .catch(console.error)
                    //     .finally(() => setIsBuyLoading(false));
                    // } else {
                    //   addCheckoutSession(selectedProduct.default_price.id, null, false, true, true)
                    //     .then(async ({ sessionId, url }) => {
                    //       if (isNative) {
                    //         await Browser.open({ url });
                    //       } else {
                    //         stripe.redirectToCheckout({ sessionId });
                    //       }
                    //     })
                    //     .catch(console.error)
                    //     .finally(() => setIsBuyLoading(false));
                    // }
                    setSelectedProduct(selectedProduct);
                    setIsConfirmInfoModalOpen(true);
                  } else {
                    updateCustomerSubscription(subscription.product.id, null, null, null, true, true, selectedProduct.id)
                      .then((pendingResult) => {
                        if (!pendingResult) return;
                        if ((pendingResult as any).error) {
                          setErrorCase((pendingResult as any).case);
                          setIsErrorPaymentModalOpen(true);
                          return;
                        }
                        setPlanUpgradeData(pendingResult);
                        setIsPlanUpgradeModalOpen(true);
                      })
                      .catch(console.error)
                      .finally(() => {
                        setPlanUpgradeLoading(false);
                      });
                  }
                }}
              >
                {isBuyLoading ? <span>{t('labels.attendi')}&hellip;</span>
                  : <span>{t(selectedProduct.is_buyable || selectedProduct.isPackage ? 'shop.acquista' : 'shop.giaAcquistato')}</span>
                }
              </Button>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Course selection modal */}
      {/* TO DO - inserire traduzioni */}
      <ConfirmationModal
        show={isConfirmModalOpen}
        onHide={() => {
          setActiveTab('ecm-courses');
          setAcceptConditions(false);
          setIsConfirmModalOpen(false);
        }}
         title={activeTab === 'ecm-plans' ? t('shop.avvisoImportante') : t('shop.confermaScelta')}
        confirmDisabled={!acceptConditions && activeTab === 'ecm-plans'}
        onConfirm={() => activeTab === 'ecm-plans' ? setIsConfirmModalOpen(false) : handleCourseSelection()}
      >
        {activeTab === 'ecm-plans' ? (
          <>
             {t('shop.pacchettoCrediti')}<br /><br />
             {t('shop.validitaPacchetto')}<br /><br />
             {t('shop.scadenzaCorsi')}<br /><br />
             <Form.Check type="checkbox" id="accept-conditions" label={t('shop.accettoCondizioni')} onChange={(e) => setAcceptConditions(!acceptConditions)} />
          </>
        ) : (
          <>
             {t('shop.modificaPreferenza')}<br />
             {t('shop.aggiungiAltriCorsi')}
          </>
        )}
      </ConfirmationModal>

      {/* Plan upgrade modal */}
      {isPlanUpgradeModalOpen && (
         <Modal className={'tootor-modal'} show={isPlanUpgradeModalOpen} onHide={handleCloseModal} backdrop={'static'} keyboard={false}>
          <Modal.Header>
            <Modal.Title>{t('profile.labels.passaggioPianoAnnualeECM')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!planUpgradeData && !subscription?.source && (
              <HighlightedCard className="mb-3">
                {t('profile.labels.pianoGestitoEsternamente')}
              </HighlightedCard>
            )}
            {!!planUpgradeData && (
              <>
                <p>
                  {t('profile.labels.staiPassandoAnnulaAlCostoECM')}{' '}
                  <span className={'font-weight-bold'}>
                    &euro; {(planUpgradeData.proratedAmountDue / 100).toFixed(2)}
                  </span>
                  .
                </p>
                {new Date('2025-11-21T00:00:00+02:00') <= new Date() && new Date() <= new Date('2025-11-30T23:59:59+02:00') ? (
                   <p>
                     {t('profile.labels.promoScontatoUpgrade1', { promoName: 'del black friday', percentAmount: '40' })}<br />
                     {t('profile.labels.promoScontatoUpgrade2')}
                   </p>
                ) : null}
                 <p>
                   {t('profile.labels.passaggioPianoDescrizioneECM', { packgeName: planUpgradeData.name, totalAmount: (planUpgradeData.amount / 1.22 / 100).toFixed(2) })}<br /><br />
                   {t('profile.labels.passaggioPianoDescrizioneECM2', { proratedAmount: (planUpgradeData.proratedAmountDue / 100).toFixed(2) })}
                 </p>
                 <p>
                   {t('profile.labels.passaggioPianoDescrizione1')}{' '}
                   <span className={'font-weight-bold'}>{formatSecondsTimestamp(new Date().getTime() / 1000, undefined, currentLocale)}</span>.<br /><br />
                   {t('profile.labels.passaggioPianoDescrizione4')}{' '}
                 </p>
                 <p>{t('profile.labels.passaggioPianoDescrizione3')}</p>
                 <p className={'mt-2'}>
                   {t('profile.labels.confermaPianoAnnualeECM')}<br /><br />
                   {t('profile.labels.confermaPianoAnnualeECM2', { proratedAmount: (planUpgradeData.proratedAmountDue / 100).toFixed(2) })}<br />
                 </p>
              </>
            )}
            <If condition={planUpgradeLoading}>
              <Then>
                 <p className={'mt-2 mb-0'}>
                   {t('labels.attendiLong')}
                 </p>
              </Then>
            </If>
          </Modal.Body>
          <Modal.Footer>
            <Button variant={'secondary'} disabled={planUpgradeLoading} onClick={() => {
              setIsBuyLoading(false);
              setPlanUpgradeLoading(false);
              setIsPlanUpgradeModalOpen(false);
            }}>
              {t('labels.annulla')}
            </Button>
            <Button
              variant={'primary'}
              disabled={planUpgradeLoading || !subscription?.source}
              onClick={() => {
                setPlanUpgradeLoading(true);
                updateCustomerSubscription(
                  !!planUpgradeData && planUpgradeData.stripeProductUpgradingTo.metadata.ECM_INCLUDED ? planUpgradeData.stripeProduct.id : selectedProduct.id,
                  null,
                  null,
                  null,
                  true,
                  null,
                  selectedProduct.id
                )
                  .then((commitResult) => {
                    if (!commitResult) return;
                    setIsSuccessModalOpen(true);
                    setIsPlanUpgradeModalOpen(false);
                  })
                  .catch(console.error)
                  .finally(() => {
                    setPlanUpgradeLoading(false);
                  });
              }}
            >
              <FontAwesomeIcon icon={faCreditCard} fixedWidth={true} /> {planUpgradeLoading ? <>{t('labels.attendi')}&hellip;</> : t('labels.confermaECM') + ((planUpgradeData ? planUpgradeData.proratedAmountDue : 0) / 100).toFixed(2) + ' €'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Success modal - redirect */}
      {isSuccessModalOpen && (
        <Modal className="tootor-modal" centered={isNative} show={isSuccessModalOpen} backdrop={'static'} onHide={() => { window.location.href = '/browse'; setIsSuccessModalOpen(false) }}>
          <Modal.Header>
            <Modal.Title>{t('plans.labels.planUpdateSuccessTitle')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t('plans.labels.planUpdateSuccess')}</p>
            <p>{t('plans.labels.planUpdateSuccess2')}</p>
          </Modal.Body>
          <Modal.Footer>
             <Button className="tootor-button tootor-button--basic" onClick={() => {
              setIsSuccessModalOpen(false);
              window.location.href = '/shop';
            }
            }>
              {t('plans.labels.planUpdateReload')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </AppShell>
  );
};

export default ShopComponent;
